import {
  AVATAR_IDS,
  AVATAR_THEMES,
  normalizeAvatar,
  type AvatarId,
  type AvatarTheme,
} from '@teaplus/shared';
import { useId } from 'react';
import { AVATAR_ART } from './avatar-art';
import { cn } from '@/lib/cn';

export const AVATAR_LIST = AVATAR_IDS.map((id) => ({ id, label: AVATAR_ART[id].label }));

export const AVATAR_THEME_LIST: { id: AvatarTheme; label: string; avatars: AvatarId[] }[] = [
  { id: 'animals', label: 'Cute animals', avatars: [...AVATAR_THEMES.animals] },
  { id: 'heroes', label: 'Heroes', avatars: [...AVATAR_THEMES.heroes] },
  { id: 'movies', label: 'Movies', avatars: [...AVATAR_THEMES.movies] },
  { id: 'series', label: 'TV shows', avatars: [...AVATAR_THEMES.series] },
];

export const avatarLabel = (id: string) => AVATAR_ART[normalizeAvatar(id)].label;
/** The avatar's two colours, for glows and backdrops around it. */
export const avatarColors = (id: string) => AVATAR_ART[normalizeAvatar(id)].bg;

export function ProfileAvatar({
  avatar,
  image,
  size = 48,
  className,
  rounded = 'xl',
}: {
  avatar: string;
  image?: string | null;
  size?: number;
  className?: string;
  rounded?: 'xl' | 'full';
}) {
  const a = AVATAR_ART[normalizeAvatar(avatar)];
  const gid = `av-${useId().replace(/:/g, '')}`;
  if (image) {
    return (
      <img
        src={image}
        alt="Profile picture"
        width={size}
        height={size}
        draggable={false}
        className={cn(
          'shrink-0 object-cover',
          rounded === 'full' ? 'rounded-full' : 'rounded-[22%]',
          className,
        )}
      />
    );
  }
  return (
    <svg
      viewBox="0 0 96 96"
      width={size}
      height={size}
      className={cn('shrink-0', rounded === 'full' ? 'rounded-full' : 'rounded-[22%]', className)}
      role="img"
      aria-label={`${a.label} avatar`}
    >
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor={a.bg[0]} />
          <stop offset="1" stopColor={a.bg[1]} />
        </linearGradient>
      </defs>
      <rect width="96" height="96" fill={`url(#${gid})`} />
      <circle cx="48" cy="42" r="36" fill="#fff" opacity=".14" />
      {a.art}
    </svg>
  );
}
